import React from 'react';
import PropTypes from 'prop-types';
import DragDropContext from 'shared/components/dragAndDropBeautiful/dragDropContext/DragDropContext';
import Draggable from 'shared/components/dragAndDropBeautiful/draggable/Draggable';
import Droppable from 'shared/components/dragAndDropBeautiful/droppable/Droppable';
import ViewHeadline from 'material-ui/svg-icons/action/view-headline';
import Clear from 'material-ui/svg-icons/content/clear';
import IconButton from 'material-ui/IconButton';
import { RULE_PROP_TYPE } from 'shared/constants/PropTypes';
import { RULES_SUBTYPES_ORDER } from 'redux/rules/RulesConstants';

const RulesOrder = ({ orderedRules, rulesActions }) => {
  const handleRowRemove = (index, subtype) => {
    rulesActions.removeOrderedRule(index, subtype);
  };

  const onDragEnd = result => {
    if(!result.destination) {
      return;
    }

    if (result.destination.droppableId === result.source.droppableId) {
      rulesActions.reOrderRules(result.source.index, result.destination.index, result.destination.droppableId);
    }
  };

  const items = [{id: 0, content: 'Content 0'}, {id: 1, content: 'Content 1'}];
  return(
    orderedRules.length > 0 &&
    <div>
      <h2>2. Manage Rule Order and Apply</h2>
      <DragDropContext onDragEnd={ onDragEnd } >
        <div>
          {
            RULES_SUBTYPES_ORDER.map(subtype => (
              <Droppable droppableId={ subtype } type={ subtype } key={ subtype }>
                { orderedRules.filter(rule => rule.mergedSubtype === subtype).map((item, index) => (
                  <Draggable
                    key={ item.id.toString() }
                    dragKey={ item.id.toString() }
                    showDragIcon={ false }
                    index={ index }
                    isDragDisabled={ items.length === 1 }
                    dragStyle={ { height: 40 } }
                    hoverColor="#f3f3f3"
                    draggingColor= { { withDragging: '#fff', withoutDragging: 'transparent' } }
                  >
                    <div className="rules-order__drag-item">
                      <div style={ { width: 50 } }><ViewHeadline color="ccc" /></div>
                      <div style={ { width: 295 } }>{ item.name }</div>
                      <div style={ { width: 410, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' } }>
                        { item.description }
                      </div>
                      <div style={ { width: 140, paddingLeft: 20 } }>{ item.subtype }</div>
                      <IconButton className="import-rule-grid__more-vert-icon" onClick={ () => handleRowRemove(index, subtype) }><Clear color="#777" /></IconButton>
                    </div>
                  </Draggable>
                )) }
              </Droppable>
            ))
          }
        </div>
      </DragDropContext>
    </div>
  );
};

RulesOrder.propTypes = {
  orderedRules: PropTypes.arrayOf(RULE_PROP_TYPE).isRequired,
  rulesActions: PropTypes.shape({
    removeOrderedRule: PropTypes.func,
    reOrderRules: PropTypes.func
  }).isRequired
};

export default RulesOrder;



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/rulesPanel/comp/profileRulesManagement/comp/rulesOrder/RulesOrder.js